import {useAtom} from "jotai";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import styled from "styled-components";
import {multiAxiosCall} from "../../common/StringUtils";
import {
  selPolicyTermsById,
  updateTerms
} from "../../services/Platform/TermsAxios";
import {tokenResultAtom} from "../login/entity/Common";
import {modalController} from "../../store";
import PlatformSectionHeader from "./PlatformSectionHeader";

function PlatformTermDetail() {
  const [termsInfo, setTermsInfo] = useState()
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const [, setModal] = useAtom(modalController)
  const {handleSubmit} = useForm({
    mode: "onSubmit",
    defaultValues: termsInfo
  })
  const onError = (error) => console.log(error)
  const navigate = useNavigate()
  const {state} = useLocation();

  useEffect(() => {
    function callbackFunc(response) {
      setTermsInfo(response[0][0]);
    }
    
    multiAxiosCall([selPolicyTermsById(state.id)], callbackFunc);
    return () => {
      setModal({isShow:false});
    }
  }, [])

  const onSubmit = () => {
    function callbackFunc(response) {
      if (response[0]) {
        toast.success("수정 되었습니다.",{onClose: () => tokenResultInfo.role === 'NORMAL' ? navigate('/board/dashboard') : navigate('/board/platformTerm'), autoClose:100, delay:0})
      } else {
        toast.warning("수정이 실패 하였습니다. 관리자한테 문의하세요")
      }
    }
    multiAxiosCall([updateTerms(termsInfo)],  callbackFunc);
  }
  const handleTermsTitle = (event) => {
    setTermsInfo({
      ...termsInfo,
      title: event.target.value
    })
  }
  const handleTermsContent = (event) => {
    setTermsInfo({
      ...termsInfo,
      content: event.currentTarget.innerHTML
    });
  };

  return (
    <>
      <TermDetailForm onSubmit={handleSubmit(onSubmit, onError)}>
        <TermDetailCard>
          <PlatformSectionHeader title="약관 상세" description="약관명과 내용을 확인하고 필요한 정보를 수정합니다."/>
          <TermDetailBody>
            <FieldGroup>
              <FieldLabel>약관명 <RequiredMark>*</RequiredMark></FieldLabel>
              <FieldDescription>사용자에게 표시되는 약관의 제목입니다.</FieldDescription>
              <TermTitleInput
                  type="text"
                  placeholder="약관명을 입력해주세요."
                  value={termsInfo?.title || ""}
                  onChange={handleTermsTitle}
              />
            </FieldGroup>
            <FieldGroup>
              <FieldLabel>약관 내용 <RequiredMark>*</RequiredMark></FieldLabel>
              <FieldDescription>사용자에게 안내할 약관의 전체 내용을 입력해주세요.</FieldDescription>
              <TermContentEditor
                  key={termsInfo?.id ?? "term-content"}
                  contentEditable
                  suppressContentEditableWarning
                  dangerouslySetInnerHTML={{__html: termsInfo?.content || ""}}
                  onInput={handleTermsContent}
                  data-placeholder="약관 내용을 입력해주세요."
              />
              <ContentGuide>HTML 태그는 숨겨지고 실제 약관 내용만 표시됩니다. 수정한 서식과 문장은 HTML 형식으로 저장됩니다.</ContentGuide>
            </FieldGroup>
          </TermDetailBody>
        </TermDetailCard>

        <TermActions>
          <TermActionGuide>
            <TermActionTitle>약관 정보 설정</TermActionTitle>
            <TermActionDescription>
              약관 제목과 내용을 확인한 뒤 수정하거나 목록으로 이동할 수 있습니다.
            </TermActionDescription>
          </TermActionGuide>
          <TermActionButtons>
            <TermCancelButton type="button" onClick={() => navigate('/board/platformTerm')}>취소</TermCancelButton>
            <TermSubmitButton type="submit">정보 수정</TermSubmitButton>
          </TermActionButtons>
        </TermActions>
      </TermDetailForm>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </>
  )
}

export default PlatformTermDetail;

const TermDetailForm = styled.form`width:100%;`;
const TermDetailCard = styled.section`
  overflow:hidden;border:1px solid #e5e8eb;border-radius:10px;background:#fff;
  box-shadow:0 5px 18px rgba(31,41,55,.045);
`;
const TermDetailBody = styled.div`display:flex;flex-direction:column;gap:24px;padding:24px;`;
const FieldGroup = styled.section`padding:18px;border:1px solid #e8ebee;border-radius:9px;background:#fafbfc;`;
const FieldLabel = styled.label`display:block;margin-bottom:5px;color:#333;font-size:12px;font-weight:700;`;
const RequiredMark = styled.span`color:#f5811f;`;
const FieldDescription = styled.p`margin:0 0 12px;color:#8a9299;font-size:9px;line-height:1.5;`;
const TermTitleInput = styled.input`
  width:100%;height:42px;box-sizing:border-box;padding:0 12px;border:1px solid #dfe3e6;
  border-radius:8px;background:#fff;color:#333;font-size:11px;
  &:hover{border-color:#f1d4c2;}
  &:focus{border-color:#f5811f;outline:0;box-shadow:0 0 0 3px rgba(245,129,31,.13);}
`;
const TermContentEditor = styled.div`
  width:100%;min-height:680px;max-height:820px;box-sizing:border-box;overflow-y:auto;
  padding:18px;border:1px solid #dfe3e6;border-radius:8px;background:#fff;
  color:#444;font-family:inherit;font-size:11px;line-height:1.75;white-space:normal;
  &:hover{border-color:#f1d4c2;}
  &:focus{border-color:#f5811f;outline:0;box-shadow:0 0 0 3px rgba(245,129,31,.13);}
  &:empty::before{color:#aaa;content:attr(data-placeholder);pointer-events:none;}

  p{margin:0 0 10px;}
  ul,ol{margin:8px 0;padding-left:22px;}
  table{width:100%;border-collapse:collapse;}
  th,td{padding:8px;border:1px solid #e5e8eb;}
`;
const ContentGuide = styled.p`margin:8px 0 0;color:#999;font-size:9px;`;
const TermActions = styled.div`
  position:sticky;bottom:0;z-index:5;display:flex;width:100%;box-sizing:border-box;
  align-items:center;justify-content:space-between;gap:8px;margin-top:22px;padding:16px 20px;
  border:1px solid #ffd7b5;border-left:4px solid #f5811f;border-radius:10px;
  background:linear-gradient(90deg,#fff8f2 0%,rgba(255,255,255,.98) 48%);
  box-shadow:0 -4px 20px rgba(245,129,31,.09);

  button {
    width:auto;min-width:108px;height:40px;margin:0;padding:0 22px;border-radius:6px;
    font-size:11px;font-weight:700;
  }

  @media(max-width:640px){align-items:stretch;flex-direction:column;}
`;
const TermActionGuide = styled.div`min-width:0;text-align:left;`;
const TermActionTitle = styled.strong`display:block;color:#2f3438;font-size:12px;font-weight:800;`;
const TermActionDescription = styled.span`
  display:block;margin-top:4px;color:#7f878e;font-size:10px;line-height:1.45;
`;
const TermActionButtons = styled.div`
  display:flex;flex-shrink:0;align-items:center;gap:8px;
  @media(max-width:640px){width:100%;flex-direction:column;button{width:100%;}}
`;
const TermCancelButton = styled.button`
  min-width:74px;height:40px;padding:0 14px;border:1px solid #ddd;border-radius:6px;
  background:#fff;color:#666;font-size:11px;font-weight:600;cursor:pointer;
  &:hover{border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
`;
const TermSubmitButton = styled.button`
  min-width:92px;height:40px;padding:0 17px;border:1px solid #f5811f;border-radius:6px;
  background:#fff4e8;color:#f5811f;font-size:11px;font-weight:700;cursor:pointer;
  &:hover{background:#ffe8d2;}
`;

